import React from 'react';
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function ConfirmModal({
  visible,
  onClose,
  symbol,
  title,
  description,
  titleYes,
  titleNo,
  onClickYes,
  onClickNo,
}) {
  const theme = useTheme();
  return (
    <Modal
      open={visible}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 360,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          padding: '42px 32px 42px',
        }}
      >
        <Grid sx={{ width: '88%', margin: 'auto' }} className="text-center">
          <Grid container justifyContent='center' alignItems='center' className="swal-question swal-close" sx={{ borderColor: "#009ef7" }}>
            <Grid className="swal-x-content" sx={{ fontSize: '3em', color: '#009ef7' }}>{symbol}</Grid>
          </Grid>
          <Typography id="modal-modal-title" sx={{ fontSize: '1.8rem', fontWeight: 700, lineHeight: '1.2', mt: 2, textAlign: 'center' }}>
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ fontSize: '0.85rem', fontWeight: 400, mt: 1.5, textAlign: 'center', color: theme.palette.mode === 'light' ? '#3f4254' : '#e0e0e0' }}>
            {description}
          </Typography>
          <Grid item container direction='row' justifyContent='center' alignItems='center' display="flex" sx={{ mt: 3 }}>
            {onClickYes && (
              <Button
                color="success"
                variant="contained"
                sx={{ fontSize: '0.9rem', fontWeight: 500, padding: '10px 30px', textTransform: 'none', color: '#fff' }}
                onClick={onClickYes}
              >
                {titleYes}
              </Button>
            )}
            <Button
              color="error"
              variant="contained"
              sx={{ marginInlineStart: onClickYes ? 1 : 0, fontSize: '0.9rem', fontWeight: 500, padding: '10px 30px', textTransform: 'none', color: '#fff' }}
              onClick={onClickNo}
            >
              {titleNo}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
